import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { getLocaleDateFormat } from '@angular/common';
import { FormularService } from 'src/app/Services/formular.service';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import {GipContractForm} from '../gipAdmContract.model'
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

@Component({
  selector: 'app-gip-contract-printer-list',
  templateUrl: './gipContractPrinterList.component.html',
  styleUrls: ['./gipContractPrinterList.component.css']
})
export class GipContractPrinterListComponent implements OnInit {

  constructor(private router: Router,
    private formularService: FormularService,
    private route: ActivatedRoute,
    private shareData: SharingDataService,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    ) { }

  urlStringParams;

  urlString: string = `admin/MS_PRINTERS_CONTRACT`;
  contractId;
  gridData;
  resourceDefinition;
  defaultFilter: string;
  contractName = GipContractForm.value.CONTRACT_NAME;

  columns = [
    { name: "STATKEY", visible: false, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "toFormPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "ID", visible: false, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "toFormPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "CONTRACT_ID", visible: false, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: true, picklistTableName: null, function: "toFormPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "G3E_ELNO", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "picklistText", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_EXPORT_SERVICE", function: "toFormPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "ORDINAL", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "text", columnSearch: false, fromToFilter: true, picklistTableName: null, function: "toFormPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
  ];

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);

    this.getUrlParams();
  }

  getUrlParams() {
    this.route.queryParams
      .subscribe(params => {
        if (params.id != undefined) {
          this.contractId = params.id;
        }
      });
      this.defaultFilter = `CONTRACT_ID eq ${this.contractId}`;
      
  }


  action(parameters) {
    this[parameters.action](parameters.element, parameters.column);
  }

  toFormPage(element, column) {
    this.router.navigate(["/gipContractPrinterForm"], { queryParams: { id: element.ID, contractId: this.contractId, isEdit: true }, queryParamsHandling: 'merge' });

  }

  toNewFormPage() {
    this.router.navigate(["/gipContractPrinterForm"], { queryParams: { contractId: this.contractId }});

  }
  backToContractForm() {
    this.router.navigate(["/gipContractForm"], { queryParams: { id: this.contractId, isEdit: true }});
  }

}
